import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const FullCircle = styled.div`
  position: absolute;
  border: solid 1.5px #f7f7f7;
  background: ${(props) => props.theme.comboGroupCircleColor};
  left: ${(props) => props.pos * props.circleGap + 'px'};
  box-sizing: border-box;
  border-radius: 50%;
  width: 35px;
  height: 35px;
`;

const DottedCircleWrapper = styled.div`
  position: absolute;
  border: solid 1.5px #f7f7f7;
  left: ${(props) => props.pos * props.circleGap + 'px'};
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.comboInMenuBackgroundColor};
`;
const DottedCircle = styled.div`
  position: absolute;
  border: solid 1.5px #f7f7f7;
  left: ${(props) => props.pos * props.circleGap + 'px'};
  display: grid;
  justify-items: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: dashed 1px
    ${(props) =>
      props.theme.comboGroupDashedCircleColor || props.theme.toggleColor};
  background-position: center;
  background-color: ${(props) => props.theme.comboInMenuBackgroundColor};
`;

const NumberWithPlusSign = styled.div`
  color: ${(props) =>
    props.theme.comboGroupDashedCircleColor || props.theme.toggleColor};
  font-size: ${(props) => (props.onlyPlus ? '16px' : '13px')};

  ::before {
    content: '+';
  }
`;

const ComboGroupCircles = ({ combo, ...props }) => {
  const numberOfGroups = combo.combo_item_groups.length;
  const circleGap = numberOfGroups > 4 ? 10 : 20;

  let trailingCirclesProps = [];
  for (let i = Math.min(4, numberOfGroups - 1); i > 0; i--) {
    trailingCirclesProps.push({
      pos: i,
      circleGap,
    });
  }

  return (
    <Wrapper>
      {trailingCirclesProps.map((trailingCircleProps, i) => (
        <FullCircle {...trailingCircleProps} key={`combo-${combo.id}-${i}`} />
      ))}
      <DottedCircleWrapper pos='0' circleGap={circleGap}>
        <DottedCircle pos='0' circleGap={circleGap}>
          <NumberWithPlusSign onlyPlus={numberOfGroups === 1}>
            {numberOfGroups > 1 && numberOfGroups}
          </NumberWithPlusSign>
        </DottedCircle>
      </DottedCircleWrapper>
    </Wrapper>
  );
};

export default ComboGroupCircles;
